import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { DefaultComponent } from './default/default.component';
import { ArticuloComponent } from './articulo/articulo.component';

export const appRoutes: Routes = [
    //{ path: '', redirectTo: 'default', pathMatch: 'full' },
    { path: '', component: DefaultComponent },
    {
        path: ':id/articulo/:art', component: ArticuloComponent
    },
    {
        path: ':id/articulo/:art/:guid', component: ArticuloComponent
    }
]

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes)
    ],
    exports: [
        RouterModule
    ]
})

export class AppRoutingModule { }


// WEBPACK FOOTER //
// C:/Workspaces/Redjurista/MAIN/Source/Asterysco.AJ.Lawtheque/GUI/Angular Components/findarticles/src/app/app.router.ts